
<form name="Educationform" (ngSubmit)="f.form.valid && educationsubmit()" #f="ngForm" novalidate>
   <div class="wrapper {{formClass}}">
   
      <div class="modal-body first-page-height">
         <div class="header-text px-0 mb-3 ml-16">
            <p class="text-center mb-0">
               School Finder
            </p>
            <small>Tell us about yourself and we’ll help you find schools and programs that are
               matches to you.<br>Time to complete is approximately 2 minutes</small>
         </div>
         <div class="modal-header mb-3 ml-8 pl-1">
            <h2 class="sub-header-text mb-0">Education Focus</h2>
            <!--<p>Find Your Fit. Tell us about yourself to find your perfect match.</p>-->
         </div>
         <div class="form-group">
            <label for="" class="ques-text"> Education goal?</label>
            <!--<select id="education-goal" class="sel-opt form-control" name="education_goal" (change)="changeEducationgoal()" [(ngModel)]="_parent.model.education_goal" required> 
           <option value="">Select educational goal</option>
           <option *ngFor='let level of levels' [value]="level.levelId">{{ level.levelTitle }}</option>
           <option value="Not Sure">Not Sure</option>
        </select>-->
            <ul id="mark-error" class="radio-choice mt-2 mb-0">
               <li *ngFor='let level of levels'>
                  <label class="radio-container">
                     <input type="radio" [value]="level.levelId" name="education_goal"
                        (change)="changeEducationgoal(level.levelId)" [checked]="checkRadioButton(level.levelId)"
                        required>{{ level.levelTitle }}
                     <span id="level" class="checkmark error-msg"></span>
                  </label>
               </li>
               <li>
                  <label class="radio-container">
                     <input type="radio" [value]="0" name="education_goal" (change)="changeEducationgoal('0')"
                        [checked]="checkRadioButton('0')" required>Not Sure
                     <span class="checkmark" style="margin-left: -2.5px;"></span>
                  </label>
               </li>
            </ul>
         </div>
         <div class="form-group">
            <label for="goal" class="ques-text"> Where would you like to study?</label>
            <!--<a href="#" data-toggle="tooltip" title="information">
         <span>
            <i class=" info-icon fas fa-info-circle pl-3"></i>
         </span>
      </a>-->
            <input id="study-state" name="study  _state_value" type="text" [(ngModel)]="_parent.model.study_state_value"
               (click)="loadStudystate()" class="form-control tm-input typeahead tm-input-info"
               [required]="_parent.model.study_state.length < 1" placeholder="Please type state name"
               autocomplete="off">
         </div>
         <div class="tags-show">
            <span class="tm-tag tm-tag-info" *ngFor="let sitem of _parent.model.study_state">
               <span>{{ sitem.name }}</span>
               <a href="javascript:void(0)" (click)="deleteStudystate(sitem.value)" class="tm-tag-remove">
                  <i class="fa fa-times-circle" aria-hidden="true"></i>
               </a>
            </span>
         </div>

         <!--<p class="text-center mb-0">
        <small >
            We respect your privacy and will not provide your contact info to any schools.
         </small>
     </p>-->
         <div class="error-display" *ngIf="errdisplay">
            <ul class="p-0">
               <li *ngFor='let msg of errormsg' class="errorclass">{{ msg }}</li>
            </ul>
         </div>
      </div>
      <div class="modal-footer m-footer text-center pt-4 flex-column">
        
   
               <a href="javascript:void(0)" (click)="clickSubmit(f.form.valid)" class="btn btn-next btn-xs px-83px">
                  NEXT<i class="fas fa-arrow-right pl-2"></i>
               </a>
            
         

            <div id="footer" class="text-center mt-3">
               <p>© {{ _parent.year }} CollegeRecon. All rights reserved.</p>
            </div>
         
      </div>

   </div>
</form>


// WEBPACK FOOTER //
// ./src/app/components/pworkflow/education/education.component.html